/** Plan limits as the API reports them (GET /v1/usage and 429 limit responses). */
export const USAGE_LIMIT_EVENT = "usage-limit-reached";
/**
 * Credit top-ups are hidden until we launch them. The flow is built end to end (the Buy credits button on the
 * usage page, POST /v1/billing/topup-checkout and the checkout.session.completed webhook); to launch, create the
 * one-time top-up price in Stripe, enter its ID in Admin → Plans & Usage → Settings, and set this to true.
 */
export const IS_TOP_UP_ENABLED = false;
export function isUsageLimitBody(value) {
    const error = value === null || value === void 0 ? void 0 : value.error;
    return error === "limit_reached" || error === "capacity_reached";
}
/** Thrown by API calls refused for a plan limit or our capacity; a dialog has already been shown for it */
export class UsageLimitError extends Error {
    constructor(body) {
        super(body.message);
        this.body = body;
        this.name = "UsageLimitError";
    }
}
/** Opens the upgrade / top-up dialog (UsageLimitDialog listens for this) */
export function reportUsageLimit(body) {
    window.dispatchEvent(new CustomEvent(USAGE_LIMIT_EVENT, { detail: body }));
}
export const CREDIT_ACTION_LABELS = {
    linkedin_enrich: "LinkedIn profile data",
    email_enrich: "email",
    phone_enrich: "phone number",
    company_enrich: "company data",
    personal_email_enrich: "personal email",
    email_verify: "email verification",
    ai_prompt: "AI prompt",
};
/** Resets are at 00:00 UTC; show them in the user's own time zone */
export function formatLocalDateTime(isoDate) {
    return new Date(isoDate).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}
export function newIdempotencyKey() {
    return crypto.randomUUID();
}
